import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Technologies We Use</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Our Web3 developers use the most recent technologies to design
              your next-generation decentralized applications.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Blockchains">
              <ul>
                <li>Ethereum</li>
                <li>Solana</li>
                <li>Cosmos</li>
                <li>Near</li>
                <li>Polkadot</li>
                <li>Avalanche</li>
                <li>Tezos</li>
                <li>Celo</li>
                <li>Fantom</li>
                <li>Aurora</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Layer2s Sidechains">
              <ul>
                <li>ZK Sync</li>
                <li>Starknet</li>
                <li>Polygon</li>
                <li>Arbitrum</li>
                <li>Optimism</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="File Storage">
              <ul>
                <li>IPFS</li>
                <li>ARWEAVE</li>
                <li>FileCoin</li>
                <li>SkyNet</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Development Environment">
              <ul>
                <li>Hardhat</li>
                <li>Truffle</li>
                <li>Foundry</li>
                <li>Brownie</li>
                <li>Anchor</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Solidity</li>
                <li>Golang</li>
                <li>JavaScript</li>
                <li>Vyper</li>
                <li>Rust</li>
                <li>Move</li>
                <li>Chainlink</li>
                <li>Flusk</li>
                <li>Web3.js</li>
                <li>Ethers.js</li>
                <li>Anchor</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
